var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 14.3901C1.16667 14.3901 0 14.3901 0 13.2235C0 12.0568 1.16667 8.5568 7 8.5568C12.8333 8.5568 14 12.0568 14 13.2235C14 14.3901 12.8333 14.3901 12.8333 14.3901H1.16667ZM7 7.39014C7.92826 7.39014 8.8185 7.02139 9.47487 6.36501C10.1313 5.70863 10.5 4.81839 10.5 3.89014C10.5 2.96188 10.1313 2.07164 9.47487 1.41526C8.8185 0.758886 7.92826 0.390137 7 0.390137C6.07174 0.390137 5.1815 0.758886 4.52513 1.41526C3.86875 2.07164 3.5 2.96188 3.5 3.89014C3.5 4.81839 3.86875 5.70863 4.52513 6.36501C5.1815 7.02139 6.07174 7.39014 7 7.39014Z",
    fill: "#5D38E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.35867492da4157e15b76cc643a14db92.svg";
export { ForwardRef as ReactComponent };